module.exports = __webpack_public_path__ + "img/helags.3c615707.jpg";